//オプションがなかったら見えなくする
const itemOptionBloc = document.querySelector(".shopify-app-block");
const itemOption = itemOptionBloc.querySelectorAll("input");
if (itemOption.length == 0) {
  itemOptionBloc.style.display = "none";
} else {
  //オプションありの時に価格が変わらない不具合用（セール時はうまくいかないかも）
  const productBox = document.querySelector(".product__info-wrapper");
  productBox.classList.add("price__container2");
  const priceBox = document.querySelector(".price_change");
  const normalPriceBox = document.querySelector(".normal_priceChange");

  //読み込み時の価格
  let firstUrl = new URL(window.location.href);
  let firstVariant = firstUrl.searchParams.get("variant");

  // console.log(firstVariant);
  let firstPrice = 0;
  if (firstVariant) {
    meta.product.variants.forEach((price_up) => {
      if (firstVariant == price_up.id) {
        firstPrice = price_up.price / 100;
      }
    });
  } else {
    firstPrice = meta.product.variants[0].price / 100;
  }

  const taxRate = 0.1; // 消費税率
  // 定価 (税込) を計算して四捨五入
  const normalPrice = Math.round(
    (firstPrice / (1 + taxRate)) * 1.5 * (1 + taxRate)
  );

  priceBox.innerHTML = `¥${firstPrice.toLocaleString()}<span class="include-tax">(税込)</span>`;
  normalPriceBox.innerHTML = `定価:¥${normalPrice.toLocaleString()}<span class="include-tax">(税込)</span>`;
  const variantBtn = document.querySelectorAll("variant-radios label");

  //バリエーション選択時に価格変更
  variantBtn.forEach((e) => {
    e.addEventListener("click", function () {
      requestAnimationFrame(function () {
        let url = new URL(window.location.href);
        // URLSearchParamsオブジェクトを取得
        let params = url.searchParams;

        meta.product.variants.forEach((price_up) => {
          if (params.get("variant") == price_up.id) {
            const changePrice = price_up.price / 100;
            const changeNormalPrice = Math.round(
              (changePrice / (1 + taxRate)) * 1.5 * (1 + taxRate)
            );
            priceBox.innerHTML = `¥${changePrice.toLocaleString()}<span class="include-tax">(税込)</span>`;
            normalPriceBox.innerHTML = `定価:¥${changeNormalPrice.toLocaleString()}<span class="include-tax">(税込)</span>`;
          }
        });
      });
    });
  });
}
// let url = new URL(window.location.href);
// // URLSearchParamsオブジェクトを取得
// let params = url.searchParams;
// console.log(meta.product.variants)
// console.log(params.get('variant'))

//オプションボタン
const optionBtn = document.querySelectorAll(
  ".ef__product-option-root .ef__product-option"
);
const options = ["印字", "蓄光シート(3か所)", "蓄光シート(2か所)"];
const options2 = ["印字の書体", "固定仕様", "抜け止縫製"];
const options3 = ["印字内容"];

optionBtn.forEach((e) => {
  let option_title = e.dataset.optionTitle;
  const element = document.createElement("span");
  element.classList.add("white_check");
  const add_tag = e.querySelector(".ef__option-value label");
  if (options.includes(option_title)) {
    e.classList.add("option_design");
    add_tag.prepend(element);
  } else if (options2.includes(option_title)) {
    e.classList.add("option_design2");
  } else if (options3.includes(option_title)) {
    e.classList.add("option_design3");
  }

  const title_change = e.querySelector("span.ef_option-title-required");
  if (option_title == "固定仕様") {
    title_change.innerHTML = `<a href="/pages/20211005kotei_lr">固定仕様とは？</a>`;
  } else if (option_title == "抜け止縫製") {
    title_change.innerHTML = `<a href="/pages/stitching">抜け止縫製とは？</a>`;
  }
});

//オプショントータル金額
const total_option = document.querySelector("p.ef__option-total-price");
total_option.innerHTML = total_option.innerHTML.replace(
  "Total add-ons",
  "オプション金額(１本につき)"
);
